/**
 * Stable per-person colors for transcript speakers. Readable on the dark background
 * and kept away from the DM's gold (#f0c36b).
 */
export const SPEAKER_PALETTE = [
  "#7fb3ff", // sky blue
  "#8fd18a", // green
  "#ff8fa3", // rose
  "#c39bff", // violet
  "#5fd4c8", // teal
  "#ff9e6b", // coral
  "#a8d65c", // lime
  "#f48fd0", // pink
  "#6fc2ff", // azure
  "#b7a2ff", // lavender
  "#66d9a0", // mint
  "#e6a3a3", // dusty red
] as const;

/** FNV-1a hash of the Discord user ID (or name if there is none) into the palette. */
export function speakerColor(key: string): string {
  let h = 0x811c9dc5;
  for (let i = 0; i < key.length; i++) {
    h ^= key.charCodeAt(i);
    h = Math.imul(h, 0x01000193);
  }
  return SPEAKER_PALETTE[(h >>> 0) % SPEAKER_PALETTE.length]!;
}
